import request from '../utils/request';

/**
 * 获取用户登录记录分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export const getLoginRecordList = (params) => {
  return request({
    url: '/login-record/list',
    method: 'get',
    params
  });
}; 